import { type StaticImageData } from 'next/image';

import { type Scalars } from '@/__generated-gql-types__/globalTypes';

// Carousel Category Images
import CarouselBusinessOperationsImage from '../assets/images/carousel/business-operations.png';
import CarouselCareerCoachingImage from '../assets/images/carousel/career-coaching.png';
import CarouselCollegeImage from '../assets/images/carousel/college.png';
import CarouselDataScienceImage from '../assets/images/carousel/data-science.png';
import CarouselDentalSchoolImage from '../assets/images/carousel/dental-school.png';
import CarouselGmatImage from '../assets/images/carousel/gmat.png';
import CarouselGreImage from '../assets/images/carousel/gre.png';
import CarouselHumanResourcesImage from '../assets/images/carousel/human-resources.png';
import CarouselInvestmentBankingImage from '../assets/images/carousel/investment-banking.png';
import CarouselLawSchoolImage from '../assets/images/carousel/law-school.png';
import CarouselLeadershipCoachingImage from '../assets/images/carousel/leadership-coaching.png';
import CarouselLegalPracticeImage from '../assets/images/carousel/legal-practice.png';
import CarouselLsatImage from '../assets/images/carousel/lsat.png';
import CarouselManagementConsultingImage from '../assets/images/carousel/management-consulting.png';
import CarouselMarketingImage from '../assets/images/carousel/marketing.png';
import CarouselMasterProgramImage from '../assets/images/carousel/masters-program.png';
import CarouselMbaImage from '../assets/images/carousel/mba.png';
import CarouselMedicalSchoolImage from '../assets/images/carousel/medical-school.png';
import CarouselPhdProgramsImage from '../assets/images/carousel/phd-programs.png';
import CarouselPlaceholderImage from '../assets/images/carousel/placeholder-image.png';
import CarouselPrivateEquityImage from '../assets/images/carousel/private-equity.png';
import CarouselProductManagementImage from '../assets/images/carousel/product-management.png';
import CarouselProductMarketingImage from '../assets/images/carousel/product-marketing.png';
import CarouselSATImage from '../assets/images/carousel/sat.png';
import CarouselSoftwareEngineeringImage from '../assets/images/carousel/software-engineering.png';
import CarouselVentureCapitalImage from '../assets/images/carousel/venture-capital.png';
import CarouselVisualArtsImage from '../assets/images/carousel/visual-arts.png';
// Department Images
import DepartmentArtsImage from '../assets/images/landing/departments/Department-Arts.png';
import DepartmentBusinessImage from '../assets/images/landing/departments/Department-Business.png';
import DepartmentDevelopmentImage from '../assets/images/landing/departments/Department-Development.png';
import DepartmentFinanceImage from '../assets/images/landing/departments/Department-Finance.png';
import DepartmentGeneralImage from '../assets/images/landing/departments/Department-General.png';
import DepartmentHealthImage from '../assets/images/landing/departments/Department-HealthandMedicine.png';
import DepartmentLawImage from '../assets/images/landing/departments/Department-Law.png';
import DepartmentProductImage from '../assets/images/landing/departments/Department-Product.png';
import DepartmentSalesImage from '../assets/images/landing/departments/Department-SalesandCustomer.png';
import DepartmentScienceImage from '../assets/images/landing/departments/Department-Science.png';
// Career Category Images
import BusinessStrategyImage from '../assets/images/landing/featured-filter-images/career/Business-Ops.png';
import GeneralCareerImage from '../assets/images/landing/featured-filter-images/career/General-Career.png';
import InvestmentBankingImage from '../assets/images/landing/featured-filter-images/career/Investment-Banking.png';
import ManagementConsultingImage from '../assets/images/landing/featured-filter-images/career/Management-Consulting.png';
import MarketingImage from '../assets/images/landing/featured-filter-images/career/Marketing.png';
import PrivateEquityImage from '../assets/images/landing/featured-filter-images/career/Private-Equity.png';
import ProductManagementImage from '../assets/images/landing/featured-filter-images/career/Product-Management.png';
import SoftwareEngineeringImage from '../assets/images/landing/featured-filter-images/career/Software-Engineering.png';
import VentureCapitalImage from '../assets/images/landing/featured-filter-images/career/Venture-Capital.png';
// School Category Images
import CollegeImage from '../assets/images/landing/featured-filter-images/school/College.png';
import DentalSchoolImage from '../assets/images/landing/featured-filter-images/school/Dental-School.png';
import LawSchoolImage from '../assets/images/landing/featured-filter-images/school/Law-School.png';
import MbaImage from '../assets/images/landing/featured-filter-images/school/MBA.png';
import MastersProgramImage from '../assets/images/landing/featured-filter-images/school/Masters-Programs.png';
import MedicalSchoolImage from '../assets/images/landing/featured-filter-images/school/Medical-School.png';
import PhdProgramsImage from '../assets/images/landing/featured-filter-images/school/PhD-Programs.png';
import PaProgramsImage from '../assets/images/landing/featured-filter-images/school/Physicians-Assistant.png';
// Test Category Images
import ActImage from '../assets/images/landing/featured-filter-images/test/ACT.png';
import DatImage from '../assets/images/landing/featured-filter-images/test/DAT.png';
import GmatImage from '../assets/images/landing/featured-filter-images/test/GMAT.png';
import GreImage from '../assets/images/landing/featured-filter-images/test/GRE.png';
import LsatImage from '../assets/images/landing/featured-filter-images/test/LSAT.png';
import McatImage from '../assets/images/landing/featured-filter-images/test/MCAT.png';
import SatImage from '../assets/images/landing/featured-filter-images/test/SAT.png';
import ToeflImage from '../assets/images/landing/featured-filter-images/test/TOEFL.png';
// Content Entry Category Images
// SubCategory Images
import BusinessImage from '../assets/images/masters-featured-images/Business.png';
import DataScienceImage from '../assets/images/masters-featured-images/Data-Science.png';
import EducationImage from '../assets/images/masters-featured-images/Education.png';
import EngineeringImage from '../assets/images/masters-featured-images/Engineering.png';
import HumanitiesImage from '../assets/images/masters-featured-images/Humanities.png';
import NaturalSciencesImage from '../assets/images/masters-featured-images/Natural-Sciences.png';
import PublicDegreesImage from '../assets/images/masters-featured-images/Public-Degrees.png';
import MBADeferredImage from '../assets/images/mba-featured-images/MBA-Deferred.png';
import MBAExecutiveImage from '../assets/images/mba-featured-images/MBA-Executive.png';
import MBAOnlineImage from '../assets/images/mba-featured-images/MBA-Online.png';
import MBAPartTimeImage from '../assets/images/mba-featured-images/MBA-PartTime.png';
import MBATraditionalImage from '../assets/images/mba-featured-images/MBA-Traditional.png';
import BiomedicalSciencesImage from '../assets/images/phd-featured-images/Biomedical-Sciences.png';
import ChemistryImage from '../assets/images/phd-featured-images/Chemistry.png';
import CognitiveAndClinicalPsychologyImage from '../assets/images/phd-featured-images/Clinical-Psychology.png';
import ComputerScienceImage from '../assets/images/phd-featured-images/Computer-Science.png';
import EconomicsImage from '../assets/images/phd-featured-images/Economics.png';
import EnvironmentalSciencesImage from '../assets/images/phd-featured-images/Environmental-Sciences.png';
import HistoryImage from '../assets/images/phd-featured-images/History.png';
import LiteratureImage from '../assets/images/phd-featured-images/Literature.png';
import MathematicsAndStatisticsImage from '../assets/images/phd-featured-images/Mathematics-Statistics.png';
import PhysicsImage from '../assets/images/phd-featured-images/Physics.png';
import PoliticalScienceImage from '../assets/images/phd-featured-images/Political-Science.png';
import { COLLEGE_CATEGORY_URN, MBA_CATEGORY_URN } from '../utils/constants';

export const getSubCategoryTitle = (
  subCategoryTitle: Possible<string>,
): string => subCategoryTitle ?? 'Specialty';

export const CATEGORY_REMAP: Record<string, string> = {
  undergrad: 'college',
};

// TODO: remove this and confirm that the backend handles the mapping
export const categoryRedirectMapToSlug = (
  categorySlug: string,
  hasActiveCoach: boolean | undefined | null,
): string => {
  if (hasActiveCoach) {
    return categorySlug;
  }
  switch (categorySlug) {
    case 'accounting':
    case 'equity-research':
    case 'f-p-and-a':
    case 'financial-planning-advising':
    case 'hedge-fund':
      return 'private-equity';
    case 'customer-success':
    case 'customer-support':
    case 'design':
    case 'human-resources':
    case 'real-estate':
      return 'general-career';
    case 'cyber-security':
    case 'engineering-other':
      return 'software-engineering';
    case 'dental-career':
    case 'dentistry':
    case 'dat':
      return 'dental-school';
    case 'medicine-career':
      return 'medical-school';
    case 'product-operations':
      return 'business-strategy-and-operations';
    case 'sales-and-trading':
      return 'sales-strategy-and-operations';
    case 'technical-program-management':
      return 'product-management';
    default:
      return categorySlug;
  }
};

export const CAREER_CATEGORY_IMAGE_MAP: Record<
  Scalars['CategoryUrn']['output'],
  StaticImageData
> = Object.freeze({
  'urn:category:business-strategy-and-operations': BusinessStrategyImage,
  'urn:category:career-development': GeneralCareerImage,
  'urn:category:investment-banking': InvestmentBankingImage,
  'urn:category:management-consulting': ManagementConsultingImage,
  'urn:category:marketing': MarketingImage,
  'urn:category:private-equity': PrivateEquityImage,
  'urn:category:product-management': ProductManagementImage,
  'urn:category:software-engineering': SoftwareEngineeringImage,
  'urn:category:venture-capital': VentureCapitalImage,
});

export const CAREER_DEPARTMENT_IMAGE_MAP: Record<
  Scalars['DepartmentUrn']['output'],
  StaticImageData
> = Object.freeze({
  'urn:department:arts-media-and-entertainment': DepartmentArtsImage,
  'urn:department:business': DepartmentBusinessImage,
  'urn:department:development': DepartmentDevelopmentImage,
  'urn:department:finance-and-accounting': DepartmentFinanceImage,
  'urn:department:general': DepartmentGeneralImage,
  'urn:department:health-and-medicine': DepartmentHealthImage,
  'urn:department:law-and-public-policy': DepartmentLawImage,
  'urn:department:product': DepartmentProductImage,
  'urn:department:sales-and-customer': DepartmentSalesImage,
  'urn:department:science': DepartmentScienceImage,
});

export const SCHOOL_CATEGORY_IMAGE_MAP: Record<
  Scalars['CategoryUrn']['output'],
  StaticImageData
> = Object.freeze({
  [MBA_CATEGORY_URN]: MbaImage,
  [COLLEGE_CATEGORY_URN]: CollegeImage,
  'urn:category:masters-programs': MastersProgramImage,
  'urn:category:medical-school': MedicalSchoolImage,
  'urn:category:dental-school': DentalSchoolImage,
  'urn:category:law-school': LawSchoolImage,
  'urn:category:phd': PhdProgramsImage,
  'urn:category:pa': PaProgramsImage,
});

export const TEST_CATEGORY_IMAGE_MAP: Record<
  Scalars['CategoryUrn']['output'],
  StaticImageData
> = Object.freeze({
  'urn:category:act': ActImage,
  'urn:category:sat': SatImage,
  'urn:category:gre': GreImage,
  'urn:category:gmat': GmatImage,
  'urn:category:mcat': McatImage,
  'urn:category:lsat': LsatImage,
  'urn:category:dat': DatImage,
  'urn:category:toefl': ToeflImage,
});

export const CATEGORY_IMAGE_MAP: Record<
  Scalars['CategoryUrn']['output'],
  StaticImageData
> = Object.freeze({
  ...CAREER_CATEGORY_IMAGE_MAP,
  ...SCHOOL_CATEGORY_IMAGE_MAP,
  ...TEST_CATEGORY_IMAGE_MAP,
});

export const CAROUSEL_CATEGORY_IMAGE_MAP: Record<
  Scalars['CategoryUrn']['output'],
  StaticImageData
> = Object.freeze({
  'urn:category:business-strategy-and-operations':
    CarouselBusinessOperationsImage,
  'urn:category:career-development': CarouselCareerCoachingImage,
  'urn:category:college': CarouselCollegeImage,
  'urn:category:data-science': CarouselDataScienceImage,
  'urn:category:design': CarouselVisualArtsImage,
  'urn:category:dental-school': CarouselDentalSchoolImage,
  'urn:category:gmat': CarouselGmatImage,
  'urn:category:gre': CarouselGreImage,
  'urn:category:human-resources': CarouselHumanResourcesImage,
  'urn:category:investment-banking': CarouselInvestmentBankingImage,
  'urn:category:law-school': CarouselLawSchoolImage,
  'urn:category:leadership-development': CarouselLeadershipCoachingImage,
  'urn:category:legal-practice': CarouselLegalPracticeImage,
  'urn:category:lsat': CarouselLsatImage,
  'urn:category:management-consulting': CarouselManagementConsultingImage,
  'urn:category:marketing': CarouselMarketingImage,
  'urn:category:masters-programs': CarouselMasterProgramImage,
  'urn:category:mba': CarouselMbaImage,
  'urn:category:medical-school': CarouselMedicalSchoolImage,
  'urn:category:phd': CarouselPhdProgramsImage,
  'urn:category:private-equity': CarouselPrivateEquityImage,
  'urn:category:product-management': CarouselProductManagementImage,
  'urn:category:product-marketing': CarouselProductMarketingImage,
  'urn:category:sat': CarouselSATImage,
  'urn:category:software-engineering': CarouselSoftwareEngineeringImage,
  'urn:category:venture-capital': CarouselVentureCapitalImage,
  'urn:category:visual-arts': CarouselVisualArtsImage,
});

export const CAROUSEL_PLACEHOLDER_IMAGE = CarouselPlaceholderImage;

export const SUBCATEGORY_IMAGE_MAP: Record<
  Scalars['SubCategoryUrn']['output'],
  StaticImageData
> = Object.freeze({
  // MBA
  'traditional-full-time-mba': MBATraditionalImage,
  'deferred-mba': MBADeferredImage,
  'executive-mba': MBAExecutiveImage,
  'part-time-mba': MBAPartTimeImage,
  'online-mba': MBAOnlineImage,
  // Masters
  'business-degrees': BusinessImage,
  'data-science-degrees': DataScienceImage,
  'education-degrees': EducationImage,
  'engineering-degrees': EngineeringImage,
  'humanities-degrees': HumanitiesImage,
  'natural-science-degrees': NaturalSciencesImage,
  'public-degrees': PublicDegreesImage,
  // PhD
  literature: LiteratureImage,
  history: HistoryImage,
  'political-science': PoliticalScienceImage,
  'cognitive-and-clinical-psychology': CognitiveAndClinicalPsychologyImage,
  'mathematics-and-statistics': MathematicsAndStatisticsImage,
  'environmental-sciences': EnvironmentalSciencesImage,
  economics: EconomicsImage,
  chemistry: ChemistryImage,
  physics: PhysicsImage,
  'biomedical-sciences': BiomedicalSciencesImage,
  'computer-science': ComputerScienceImage,
});

const CATEGORY_NAME_REMAP: Record<string, string> = {
  'traditional-full-time-mba': 'Full-Time MBA',
};

export const getCategoryDisplayName = (
  categorySlug: string,
  categoryName: string,
) => {
  return CATEGORY_NAME_REMAP[categorySlug] ?? categoryName;
};
